import React from 'react';
import { Dropdown, type DropdownItem } from '../../Dropdown';
import ColorPicker from '../../ColorPicker';
import WidgetRow from '../WidgetRow';

interface Props {
  fontSize: number;
  fontColor: string;
  bgColor: string;
  onFontSizeChange: (val: number) => void;
  onFontColorChange: (val: string) => void;
  onBgColorChange: (val: string) => void;
}

export const fontSizeItems: DropdownItem[] = [
  { id: 8, name: '8px (存在兼容风险)' },
  { id: 10, name: '10px (存在兼容风险)' },
  { id: 12, name: '12px' },
  { id: 14, name: '14px' },
  { id: 16, name: '16px' },
  { id: 18, name: '18px' },
  { id: 24, name: '24px' },
];

function WidgetRowFont({
  fontColor,
  fontSize,
  bgColor,
  onFontSizeChange,
  onBgColorChange,
  onFontColorChange,
}: Props) {
  return (
    <WidgetRow>
      <div className="mb-10">字号：</div>
      <Dropdown
        items={fontSizeItems}
        selected={fontSize}
        onChange={onFontSizeChange}
      />
      <ColorPicker
        className="mt-20"
        colorString={fontColor}
        onChange={onFontColorChange}
      >
        <ColorPicker.Header>字体颜色：</ColorPicker.Header>
        <ColorPicker.Bar disableAlpha />
      </ColorPicker>
      <ColorPicker
        className="mt-20"
        colorString={bgColor}
        onChange={onBgColorChange}
      >
        <ColorPicker.Header>背景颜色：</ColorPicker.Header>
        <ColorPicker.Bar />
      </ColorPicker>
    </WidgetRow>
  );
}

export default WidgetRowFont;
